// Shared by the calendar and the checkout action. Dates are Japan calendar dates.
(function () {
  "use strict";
  const element = document.getElementById("delivery-settings");
  const value = element ? JSON.parse(element.textContent) : "";
  function normalize(value) {
    const match = String(value || "").trim().match(/^(\d{4})(?:-(\d{1,2})-(\d{1,2})|年(\d{1,2})月(\d{1,2})日)$/);
    if (!match) return null;
    const year = Number(match[1]);
    const month = Number(match[2] || match[4]);
    const day = Number(match[3] || match[5]);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  }
  const blockedDates = [...new Set(String(value || "").split(/[,，、\s]+/).map(normalize).filter(Boolean))];
  function today() {
    const parts = new Intl.DateTimeFormat("en-US", { timeZone: "Asia/Tokyo", year: "numeric", month: "2-digit", day: "2-digit" }).formatToParts(new Date());
    const fields = Object.fromEntries(parts.map(part => [part.type, part.value]));
    return `${fields.year}-${fields.month}-${fields.day}`;
  }
  window.deliveryRules = {
    blockedDates,
    normalize,
    canCheckout(mode, date) {
      const key = mode === "now" ? today() : normalize(date);
      return Boolean(key && key >= today() && !blockedDates.includes(key));
    }
  };
})();
